import { Link } from 'gatsby';
import React from 'react';
import styled from "styled-components";
import KalkulackaImg from "../assets/img/kalkulacka.svg";
import Img from "gatsby-image"
import { StaticQuery, graphql } from "gatsby"

import Telefon from "../assets/img/telefon.svg";

const ArticleWidgetInner = styled.div`
  background: #F3F1EB;
  padding: 30px;
  border-radius: 10px;
  margin: 60px auto;

  @media (max-width: 400px) {
    padding: 20px;
    margin: 40px auto;
  }

  h2 {
    font-family: Visuelt-Medium,Helvetica !important;
    font-size: 23px !important;
    color: #0c1c31;
    margin: 0 !important; 

    @media (max-width: 900px) {
      font-size: 22px !important;
      line-height: 31px;
    }

    @media (max-width: 540px) {
      font-size: 20px !important;
      line-height: 28px;
    }
  }

  ul {
    padding: 0 !important; 

    li {
      font-family: Visuelt-Regular,Helvetica;
      font-size: 17px;
      color: #282828;
      line-height: inherit;
      margin: 0px auto;
      position: relative;
      list-style: none;
      padding-left: 20px;
      margin: 15px 0;

      &::before {
        position: absolute;
        left: 0;
        top: 2px;
        content: "";
        padding: 8px 16px 8px 8px;
        background-repeat: no-repeat;
        background-position: left center;
        background-size: 8px;
        background-image: url("data:image/svg+xml,%3Csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.9565 0.0800942C19.7244 -0.427904 23.5804 1.49209 26.5764 5.51207C29.5724 9.53206 30.1324 12.204 29.9764 15C29.7204 19.568 27.6004 23.264 25.8484 25.692C24.0964 28.12 21.8084 30.016 17.6964 30C13.6684 29.984 6.36447 28.556 3.29648 24.932C0.228495 21.308 -0.727502 17.032 0.552494 11.96C1.83249 6.88807 4.18848 0.588092 11.9565 0.0800942Z' fill='%23bb984c'/%3E%3C/svg%3E%0A");
      }
    }
  }

  p {
    margin: 15px auto !important;
  }

  a {
    font-family: Visuelt-Medium;
    font-size: 18px;
    color: #000;
    text-align: center;
    max-width: 290px;
    display: block;
    padding: 20px 0;
    border-radius: 5px;
    background: #e5ddc4;
    text-decoration: none;
    margin-top: 30px;

    &:hover {
      background: #d9ceae;
    }
  }

  .support {
    display: flex;
    align-items: center;
    margin-top: 30px;

    @media (max-width: 500px) {
      display: block;
    }

    .rightSupp {
      margin-left: 25px;

      @media (max-width: 500px) {
        margin-left: 0;
        margin-top: 15px;
      }

      .phone {
        display: flex;
        align-items: center;

        padding: 0;
        background: none;
        margin: 0;

        img {
          height: 20px;
          margin-right: 12px;
          margin-top: -1px;
        }

        span {
          font-family: Visuelt-Medium;
          font-size: 24px;
          color: #0c1c31;
        }
      }

      .kDispozici {
        width: fit-content;
        margin: 0 auto;
        margin-top: 10px;

        @media (max-width: 500px) {
          margin-left: 0;
        }

        .greenDot {
          background: #49B25D;
          height: 10px;
          width: 10px;
          border-radius: 100%;
          animation: pulse 2s infinite;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          font-family: Visuelt-Medium;
          font-size: 16px;
          color: #48B15C;
          line-height: 24px;
          vertical-align: middle;
          margin-left: 10px;
        }

        @keyframes pulse {
          0% {
            opacity: 1;
          }

          50% {
            opacity: 0.25;
          }

          100% {
            opacity: 1;
          }
        }
      }
    }
  }
`;

const ArticleWidgetZaveti = () => {

  return (
    <ArticleWidgetInner>
      <h2>Potřebujete pomoci sepsat závěť?</h2>
      <p>Vytvořte si vlastní závěť do 15 minut přes naší aplikaci. Dokument vám potom zkontrolují experti na dědické právo. Vše si vyzkoušíte zdarma, bez kreditní karty. Platíte až těsně před tiskem (2 190 Kč).</p>
      <Link to="/zaveti/">Začít zdarma</Link>

      <div className="support">
        <StaticQuery
          query={graphql`
            query {
              file(relativePath: { eq: "podpora.png" }) {
                childImageSharp {
                  fixed(width: 150, quality: 100) {
                    ...GatsbyImageSharpFixed_noBase64
                  }
                }
              }
            }
          `}
          render={data => (
            <Img className="obrazek" alt="Naše podpora" fixed={data.file.childImageSharp.fixed} />
          )}
        />
        <div className="rightSupp">
          <a href="tel:315558136" className="phone">
            <img src={Telefon} alt="" />
            <span>315 558 136</span>
          </a>
          <div className="kDispozici">
            <div className="greenDot"></div>
            <span>Jsme k dispozici 24/7</span>
          </div>
        </div>
      </div>
    </ArticleWidgetInner>
  );
}

export default ArticleWidgetZaveti;
